import { logos } from "../../assets";

export const LoginHeader = () => {
	return (
		<>
			<div className="w-full flex justify-center items-center">
				<img className="text-center " src={logos.inmersysLogin} alt="Logo de inmersys" />
			</div>
            <p className="text-center text-white text-2xl font-bold pt-4">¡Bienvenido a Plataforma XR Training!</p>
			<p className="text-center text-white text-base font-base py-4">
				Ingresa tu correo electrónico y contraseña para <br /> iniciar sesión.
			</p>
		</>
	);
};
